import { CountUp } from 'countup.js';
import SmoothScroll from 'smooth-scroll';
import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';
import animateDesktopNav from './animateDesktopNav';
import animateMobileNav from './animateMobileNav';
import animateScroll from './animateScroll';
import scrollSpy from './scrollSpy';

import '../sass/main.scss';

// Initializing carousel

const aboutUsSlider = tns({
  container: '.slide-1__slide',
  gutter: 20,
  mouseDrag: true,
  touch: true,
  swipeAngle: false,
  preventActionWhenRunning: true,
  controls: true,
  controlsText: ["<", ">"],
  autoWidth: true,
  autoplay: true,
  autoplayTimeout: 4000,
  autoplayButtonOutput: false,
  nav: false,
  rewind: true,
  speed: 400,
  responsive: {
    640: {
      controls: true,
      touch: true,
      mouseDrag: true,
      gutter: 15,
    },
    900: {
      controls: true,
      touch: true,
      mouseDrag: true,
      gutter: 20,
    }
  }
})

const gallerySlider = tns({
  container: '.slider2',
  gutter: 20,
  mouseDrag: true,
  touch: true,
  swipeAngle: false,
  preventActionWhenRunning: true,
  controls: false, // Disabled controls for gallery slider
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayButtonOutput: false,
  nav: false,
  rewind: true,
  speed: 400,
  responsive: {
    1200: {
      items: 5,
      touch: true,
      mouseDrag: true,
    },
    1000: {
      items: 4,
      touch: true,
      mouseDrag: true,
    },
    700: {
      items: 3,
      touch: true,
      mouseDrag: true,
    },
    600: {
      items: 2,
      touch: true,
      mouseDrag: true,
      gutter: 15,
    },
    0: {
      items: 1,
      touch: true,
      mouseDrag: true,
      gutter: 10,
    }
  }
});

// Initializing Count up
const countUpWorkers = new CountUp('count-up-workers', 170, { duration: 3 });
const countUpExperience = new CountUp('count-up-experience', 40, { duration: 3 });
const countUpProdBase = new CountUp('count-up-daily-prod', 1.4, { duration: 3, decimalPlaces: 1 });
const countUpMonthlyCap = new CountUp('count-up-yearly-prod', 260, { duration: 3 });

const statsSec = document.querySelector('.stats__cards');
const statsOptions = {
  thresholds: 1,
  rootMargin: '0px 0px -100px 0px'
};

const statsCountUp = new IntersectionObserver(function (entries, statsCountUp) {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      return;
    }
    countUpWorkers.start();
    countUpExperience.start();
    countUpProdBase.start();
    countUpMonthlyCap.start();
    statsCountUp.unobserve(entry.target);
  })
}, statsOptions);

statsCountUp.observe(statsSec);

// Initializing smooth scroll
const isMobileContactUs = window.matchMedia('(max-width: 900px)');

const scroll = new SmoothScroll('a[href*="#"]', {
  header: '.navigation',
  speed: 500,
  durationMin: 1500,
  offset: function (anchor, toggle) {
    if ((toggle.id === 'nav-contact-us') && isMobileContactUs.matches) {
      return -5;
    } else if (toggle.id === 'nav-contact-us') {
      return -100;
    } else {
      return 40;
    }

  },
  easing: 'easeInOutQuart',
});

// detect if it is the device is mobile
const isDesktop = window.matchMedia('(min-width: 901px)');

// Initializing nav animations and scroll animations
animateDesktopNav(isDesktop);
animateMobileNav();
animateScroll();
scrollSpy(isDesktop);
